angular.module("app").controller("EditUserPageController", [
    '$scope',
    'preloadedRoles',
    'preloadedUser',
    'userService',
    'errorHandler',
    'logger',
    'deepCompare',
    function ($scope, preloadedRoles, preloadedUser, userService, errorHandler, logger, deepCompare) {
        var userPristine = angular.copy(preloadedUser);

        $scope.roles = angular.copy(preloadedRoles.roles || []);
        $scope.user = angular.copy(preloadedUser);
        
        $scope.tooltip = {
            name: "",
            userName: "",
            confirmPassword: ""
        };

        $scope.submitEditUserForm = function () {
            var changes = deepCompare.getChanges(angular.copy(userPristine), $scope.user);

            changes.id = $scope.user.id;
            changes.re_password = $scope.edit_user_form.confirmPassword.$viewValue;

            userService.editUser({user: changes}).then(
                function (response) {
                    if (response.status == "ok") {
                        userPristine = angular.copy(response.user);
                        logger.logSuccess("User has been successfully updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.getChanges = function () {
            return deepCompare.isEqual($scope.user, angular.copy(preloadedUser));
        };
    }
]);